import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Paper, Chip, IconButton, Typography } from "@material-ui/core";
import TodayIcon from "@material-ui/icons/Today";

import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    minHeight: 50,
    justifyContent: "left",
    flexWrap: "wrap",
    listStyle: "none",
    padding: theme.spacing(0.5),
    margin: 0,
  },
  chip: {
    margin: theme.spacing(0.5),
  },
}));

export const sortDate = (dateList) => {
  const dateUtil = new DateFnsUtils();
  let closureDateList = [...dateList];
  if (dateList.length > 1) {
    return closureDateList.sort((a, b) => {
      if (!dateUtil.isAfter(a.date, b.date)) {
        return -1;
      }
      if (dateUtil.isAfter(a.date, b.date)) {
        return 1;
      }

      // a must be equal to b
      return 0;
    });
  }
  return [...dateList];
};

const UPSClosureDates = ({
  step,
  holidayIdentifier,
  holidayIdentifierHandler,
  closureDateList,
  closureDateHandler,
  closureDateDeleteHandler,
  disableElement,
}) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);

  const dateUtil = new DateFnsUtils();

  const disableDates = (date) => {
    const dateStringArr = closureDateList.map((dt) =>
      dt.date.toLocaleDateString()
    );
    const selectedDateString = date.toLocaleDateString();

    return dateStringArr.includes(selectedDateString);
  };

  return (
    <>
      {step === "17" && (
        <>
          <span>Closure Dates</span>
          <br />
          <label htmlFor="holiday">
            <input
              data-testid="upsClosureDate-checkbox"
              type="checkbox"
              id="holiday"
              name="holiday"
              onClick={holidayIdentifierHandler}
              checked={holidayIdentifier}
              disabled={disableElement}
            />
            Standard National Holidays
          </label>
          <div style={{ display: "flex", minWidth: "50%" }}>
            <div style={{ flex: 1 }}>
              <Paper component="ul" className={classes.root} variant="outlined">
                {sortDate(closureDateList).map((data) => {
                  return (
                    <li key={data.key} data-testid="upsClosureDate-list-item">
                      <Chip
                        variant="outlined"
                        label={data.label}
                        onDelete={
                          disableElement ? null : closureDateDeleteHandler(data)
                        }
                        className={classes.chip}
                      />
                    </li>
                  );
                })}
              </Paper>
            </div>
            <div style={{ flex: 0 }}>
              <IconButton
                data-testid="upsClosureDate-calendar-button"
                color="primary"
                aria-label="calendar"
                component="span"
                onClick={() => setIsOpen(true)}
                disabled={closureDateList.length >= 20 || disableElement}
              >
                <TodayIcon />
              </IconButton>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  open={isOpen}
                  autoOk
                  onOpen={() => setIsOpen(true)}
                  onClose={() => setIsOpen(false)}
                  onChange={closureDateHandler}
                  TextFieldComponent={() => null}
                  shouldDisableDate={disableDates}
                />
              </MuiPickersUtilsProvider>
            </div>
          </div>
          <Typography
            variant="caption"
            display="block"
            gutterBottom
            color="textSecondary"
          >
            You can select upto 20 dates.
          </Typography>
        </>
      )}
    </>
  );
};

export default UPSClosureDates;
